<template>
  <div class="yx-statistics-jxf-page main-layout">
    <CCollapseItem>
      <template slot="title-left"> 专业调整统计 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="导出" @click="exportExcel">
            <i class="iconfont icon-daochu3" :class="{ disabled: isExport }"></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="
            idList = [];
            pageGet(true);
          "
        ></table-btns>
      </div>
      <div class="div-scroll">
        <c-table
          :data="pageData"
          :tableColumns="tableColumns"
          :pagination="pageParams"
          @change="pageGet"
          @selectionChange="selectionChange"
          v-loading="pageLoading"
        >
          <template slot="status" slot-scope="scope">
            <span>{{
              scope.row.isOrNot == null
                ? "-"
                : scope.row.isOrNot == 0
                ? "否"
                : "是"
            }}</span>
          </template>
          <template slot="custom" slot-scope="scope">
            <div class="contr-btn-group" v-if="scope.row.isOrNot == 1">
              <div
                class="contr-btn"
                title="详情"
                @click="handeShowDetail(scope.row.studentId)"
              >
                <img src="../../../../../assets/images/icon/detail.png" />
              </div>
            </div>
          </template>
        </c-table>
      </div>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      title="详情"
      :visible.sync="dialogVisible"
      width="70%"
    >
      <div class="pre-detail-container">
        <div class="div-scroll">
          <major-detail :detailInfo="detailInfo"></major-detail>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MExcel from "@/mixins/MExcel.js";
import Configs from "./data/major";
import majorDetail from "./majorDetail.vue";
import CSearch from "@/components/CSearch/index.vue";
import CTable from "@/components/CTable/index.vue";
import TableBtns from "@/components/TableBtns/index.vue";
import { getOrgOptions } from "@/libs/searchSelect.js";
let mPage = MPage({
  pagePath: "/welcome-live/statistics/oneForecastLinkListPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    studentName: "",
    collegeId: "",
    departmentId: "",
    majorId: "",
    classId: "",
    linkId: "",
    isOrNot: null,
  },
  pageExportPath: "/welcome-live/statistics/exportExcel/oneForecast",
  pageExportParams: {},
});
export default {
  mixins: [mPage],
  name: "",
  components: { CSearch, CTable, TableBtns, majorDetail },
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      SUCCESS_CODE: "",
      isFold: false,
      searchItems,
      tableColumns,
      idList: [],
      linkId: "",
      dialogVisible: false, // 详情弹框
      detailInfo: [],
      isExport: false, // 是否导出
      message: null,
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    getOrgOptions(this, { type: "college" }, 0, null);
    this.linkId = this.$route.params.linkId;
    this.pageParams.linkId = this.linkId;
  },
  mounted() {},
  methods: {
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.studentId);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.idList = [];
      this.searchItems[1].options = [];
      this.searchItems[2].options = [];
      this.searchItems[3].options = [];
      this.pageParams = {
        studentName: "",
        collegeId: "",
        departmentId: "",
        majorId: "",
        classId: "",
        linkId: this.linkId,
        isOrNot: null,
      };
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    exportExcel() {
      if (this.isExport) {
        return;
      } else {
        this.isExport = true;
        this.message = this.$message({
          message: "数据正在导出中，请稍候！",
          duration: 0,
          type: "warning",
          center: true,
        });
        this.pageExportParams = Object.assign({}, this.pageParams);
        if (this.idList.length) {
          this.pageExportParams.studentIdStr = this.idList.join();
        }
        this.pageExport();
      }
    },
    pageExportAfterFn() {
      this.isExport = false;
      this.message.close();
      this.message = null;
      this.refresh();
      this.pageExportParams = {};
    },
    // 显示详情
    handeShowDetail(id) {
      this.getDetailInfo(id);
      this.dialogVisible = true;
    },
    getDetailInfo(studentId) {
      let params = { studentId };
      this.$http
        .get("/oa/welcome/exchangeMajor/getHistoryList", { params })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.detailInfo = res.data;
          } else {
            this.detailInfo = [];
          }
        })
        .catch((err) => {
          this.detailInfo = [];
        });
    },
  },
};
</script>
